import { SxProps } from '@mui/material'

import theme from '../../../../styles/themes/default.theme'

const styles = {
  card: (isSelected: boolean, isDisabled?: boolean): SxProps => ({
    width: '100%',
    cursor: isDisabled ? 'not-allowed' : 'pointer',
    borderRadius: theme.shape.borderRadius / 4,
    border: `2px solid ${theme.palette.grey[300]}`,
    borderColor: isDisabled
      ? theme.palette.error.light
      : isSelected
        ? theme.palette.primary.main
        : theme.palette.grey[300],
    bgcolor: isDisabled
      ? theme.palette.action.disabledBackground
      : isSelected
        ? theme.palette.tertiary?.main ?? '#F5F3FF'
        : 'background.paper',
    opacity: isDisabled ? 0.6 : 1,
    transition: 'all 0.2s',
    '&:hover': isDisabled ? {} : { borderColor: theme.palette.grey[400] }
  }),

  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'start',
    mb: 1.5
  } as SxProps,

  locationName: {
    fontWeight: 600,
    fontSize: 15,
    lineHeight: 1.4,
    letterSpacing: '-0.01em',
    color: 'text.primary'
  } as SxProps,

  icon: {
    flexShrink: 0,
    mt: 0.25
  } as SxProps,

  addressRow: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 1,
    mb: 1
  } as SxProps,

  addressText: {
    fontSize: 14,
    lineHeight: 1.5,
    letterSpacing: '0.01em'
  } as SxProps,

  phoneRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
    mb: 1
  } as SxProps,

  phoneText: {
    fontSize: 14,
    lineHeight: 1.5
  } as SxProps,

  hoursButton: {
    mt: 1,
    textTransform: 'none',
    fontSize: 14
  } as SxProps,

  expandIcon: (showHours: boolean): SxProps => ({
    transform: showHours ? 'rotate(180deg)' : 'rotate(0deg)',
    transition: 'transform 0.2s'
  }),

  hoursContainer: {
    mt: 2,
    pl: 2
  } as SxProps,

  hoursRow: {
    display: 'flex',
    justifyContent: 'space-between',
    py: 0.5,
    gap: 2
  } as SxProps,

  dayLabel: {
    fontWeight: 500,
    textTransform: 'capitalize',
    fontSize: 14
  } as SxProps,

  closedAlert: {
    mt: 2
  } as SxProps
}

export default styles
